import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

//CSS
import styles from "./excursion.module.less";

export const SpecialExcursion = ({specialExcursionInfo, getTotalPax, specialExcursion, setSpecialExcursion}) => {

  const [t] = useTranslation("vtform");
  const [selectedSessionLoro, setSelectedSesionLoro] = useState(null);
  const [selectedSessionSiam, setSelectedSesionSiam] = useState(null);
  let listSessionsLoro = null;
  let listSessionsSiam = null;

  //--------------------------------------------------------------------------------------------------------------------
  function selectSessionLoro(session) {
    setSelectedSesionLoro(specialExcursionInfo.sessions[2][session]['date']);
  }

  function selectSessionSiam(session) {
    setSelectedSesionSiam(specialExcursionInfo.sessions[3][session]['date']);
  }

  //select language por defecto
  useEffect(() => {
    if (selectedSessionLoro != null && selectedSessionSiam != null){
      setSpecialExcursion(
        {
          loro: specialExcursionInfo.sessions[2][selectedSessionLoro],
          siam: specialExcursionInfo.sessions[3][selectedSessionSiam]
        }
      )
    }

  },[selectedSessionLoro,selectedSessionSiam]);

  if (specialExcursionInfo != null && specialExcursionInfo.hasOwnProperty('sessions')) {
    if (specialExcursionInfo.sessions.hasOwnProperty('2')){
      listSessionsLoro = Object.keys(specialExcursionInfo.sessions[2]).map(session => {
        return (
          <div className={styles.session} key={session}
               className={getTotalPax() <= specialExcursionInfo.sessions[2][session]['available'] ? selectedSessionLoro == specialExcursionInfo.sessions[2][session]['date'] ? styles.sessionselected : styles.session : styles.sessiondisable}
               onClick={()=> getTotalPax() <= specialExcursionInfo.sessions[2][session]['available'] ? selectSessionLoro(session) : null}
          >
            {specialExcursionInfo.sessions[2][session]['time']} {/*[{specialExcursionInfo.sessions[session]['available']}]*/}
          </div>
        )
      });
    }
    if (specialExcursionInfo.sessions.hasOwnProperty('3')){
      listSessionsSiam = Object.keys(specialExcursionInfo.sessions[3]).map(session => {
        return (
          <div className={styles.session} key={session}
               className={getTotalPax() <= specialExcursionInfo.sessions[3][session]['available'] ? selectedSessionSiam == specialExcursionInfo.sessions[3][session]['date'] ? styles.sessionselected : styles.session : styles.sessiondisable}
               onClick={()=> getTotalPax() <= specialExcursionInfo.sessions[3][session]['available'] ? selectSessionSiam(session) : null}
          >
            {specialExcursionInfo.sessions[3][session]['time']} {/*[{specialExcursionInfo.sessions[session]['available']}]*/}
          </div>
        )
      });
    }
  }

  if (listSessionsLoro == null && listSessionsSiam == null) return null;

  return (
    <div className={styles.specialexcursion}>
      <div className={styles.title}>{t('vtspecialexcursion.Seleccione una sesión para visitar el Loro Parque')}</div>
      <div className={styles.sessions}>
        {listSessionsLoro}
      </div>
      <div className={styles.title}>{t('vtspecialexcursion.Seleccione una sesión para visitar el Siam Park')}</div>
      <div className={styles.sessions}>
        {listSessionsSiam}
      </div>
    </div>
  );

}

export default SpecialExcursion;